import { Share2 } from "lucide-react";

export const FloatingShare = () => {
  const handleShare = async () => {
    try {
      if (navigator.share) {
        await navigator.share({
          title: document.title,
          url: window.location.href,
        });
      } else {
        await navigator.clipboard.writeText(window.location.href);
        alert("Link paket berhasil disalin");
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <button
      onClick={handleShare}
      data-testid="floating-share-btn"
      className="fixed bottom-24 right-6 z-50 bg-accent text-white shadow-xl rounded-full px-5 py-3 flex items-center gap-2 hover:bg-accent/90 transition"
    >
      <Share2 size={18} />
      <span className="text-sm font-medium">
        Bagikan
      </span>
    </button>
  );
};
